<ng-template #externFormBody>
    <div class="empfaenger-dialog__section-label"><span class="num">1</span> Schlachthof</div>

    <button type="button" class="empfaenger-dialog__slaughter-card" (click)="openSchlachthofDialog()">
        <span class="slaughter-icon">
            <mat-icon>factory</mat-icon>
        </span>
        <span class="slaughter-text">
            <strong>{{ schlachthof ? (schlachthof.bezeichnung_final || schlachthof.bezeichnung) : 'Schlachthof auswählen' }}</strong>
            <span *ngIf="schlachthof">
                {{ schlachthof.vvvo ? ('VVVO ' + schlachthof.vvvo + ' · ') : '' }}Geändert antippen
            </span>
        </span>
        <span
            class="slaughter-actions slaughter-delete"
            *ngIf="schlachthof"
            (click)="$event.stopPropagation(); deleteSchlachthof()"
            aria-label="Schlachthof entfernen"
        >
            <mat-icon>close</mat-icon>
        </span>
        <mat-icon class="slaughter-chevron">chevron_right</mat-icon>
    </button>

    <div class="empfaenger-dialog__divider">ODER</div>

    <div class="empfaenger-dialog__section-label"><span class="num">2</span> Kontakte</div>

    <div class="empfaenger-dialog__kontakte-scroll" *kienePermission="[9601]">
        <kiene-betriebskontakt-auswahl
            [config]="kontakteConfig"
            [selectedKontakte]="tempSelectedKontakte"
            [disabled]="isSaving"
            (kontakteSelected)="onKontakteAusgewaehlt($event)"
            (selectionChanged)="onKontakteSelectionChanged($event)"
        ></kiene-betriebskontakt-auswahl>
    </div>
</ng-template>

<ng-template #internFormBody>
    <mat-form-field class="empfaenger-dialog__zielbetrieb-search" appearance="outline">
        <mat-label>Suchen</mat-label>
        <input matInput type="text" [formControl]="zielbetriebSearchCtrl" />
        <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <ul *ngIf="!isLoading" class="empfaenger-dialog__zielbetrieb-list">
        <li *ngFor="let ziel of zielbetriebKandidaten" class="empfaenger-dialog__zielbetrieb-li">
            <div
                class="empfaenger-dialog__zielbetrieb-entry"
                role="button"
                tabindex="0"
                [class.empfaenger-dialog__zielbetrieb-entry--active]="isSameZielbetrieb(selectedZielbetrieb, ziel)"
                (click)="waehleZielbetrieb(ziel)"
                (keydown.enter)="waehleZielbetrieb(ziel)"
                (keydown.space)="waehleZielbetrieb(ziel); $event.preventDefault()"
            >
                <h4 class="empfaenger-dialog__zielbetrieb-name">{{ ziel.bezeichnung_final }}</h4>
                <p class="empfaenger-dialog__zielbetrieb-meta">{{ ziel.vvvo }}</p>
                <p class="empfaenger-dialog__zielbetrieb-meta">{{ ziel.zusatz_final }}</p>
            </div>
        </li>
    </ul>

    <div *ngIf="!isLoading && zielbetriebKandidaten.length === 0" class="empfaenger-dialog__empty">
        Keine Betriebe gefunden.
    </div>
</ng-template>

<ng-template #empfaengerFormBody>
    <div class="empfaenger-dialog" [class.empfaenger-dialog--embedded]="embeddedInStepper">
        <div *ngIf="isLoading" class="empfaenger-dialog__loading">
            <mat-spinner diameter="32"></mat-spinner>
        </div>

        <ng-container *ngIf="!isLoading">
            <mat-form-field *ngIf="showDatumAbgang" class="empfaenger-dialog__datum" appearance="outline">
                <mat-label>Ausstalldatum</mat-label>
                <input
                    matInput
                    readonly
                    [formControl]="datumAbgangCtrl"
                    [matDatepicker]="datumAbgangPicker"
                />
                <mat-datepicker-toggle matSuffix [for]="datumAbgangPicker"></mat-datepicker-toggle>
                <mat-datepicker #datumAbgangPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="empfaenger-dialog__kommentar" appearance="outline">
                <mat-label>Kommentar</mat-label>
                <textarea
                    matInput
                    rows="2"
                    maxlength="250"
                    [formControl]="kommentarCtrl"
                ></textarea>
            </mat-form-field>

            <ng-container *ngIf="isUmstallenIntern; else externForm">
                <ng-container *ngTemplateOutlet="internFormBody"></ng-container>
            </ng-container>
            <ng-template #externForm>
                <ng-container *ngTemplateOutlet="externFormBody"></ng-container>
            </ng-template>
        </ng-container>
    </div>
</ng-template>

<ng-container *ngIf="!embeddedInStepper">
    <div class="empfaenger-dialog-shell">
        <header class="empfaenger-dialog-shell__head">
            <span class="empfaenger-dialog-shell__eyebrow">
                <span class="dot"></span>
                {{ shellEyebrow }}
            </span>
            <h2 class="empfaenger-dialog-shell__title">{{ shellTitle }}</h2>
            <p class="empfaenger-dialog-shell__hint">{{ shellIntro }}</p>

            <button
                type="button"
                class="empfaenger-dialog-shell__close"
                aria-label="Schließen"
                (click)="closeDialog()"
                [disabled]="isSaving"
            >
                <mat-icon>close</mat-icon>
            </button>
        </header>

        <div mat-dialog-content>
            <ng-container *ngTemplateOutlet="empfaengerFormBody"></ng-container>
        </div>

        <div mat-dialog-actions class="empfaenger-dialog-shell__foot">
            <span class="foot-hint">{{ footerHint }}</span>
            <div class="foot-actions">
                <button type="button" mat-stroked-button (click)="closeDialog()" [disabled]="isSaving">Abbrechen</button>
                <button
                    type="button"
                    mat-flat-button
                    color="primary"
                    (click)="save()"
                    [disabled]="isLoading || isSaving"
                >
                    {{ submitButtonLabel }}
                </button>
            </div>
        </div>
    </div>
</ng-container>

<div *ngIf="embeddedInStepper" class="empfaenger-dialog-shell empfaenger-dialog-shell--embedded">
    <div class="empfaenger-dialog-shell__embedded-scroll">
        <ng-container *ngTemplateOutlet="empfaengerFormBody"></ng-container>
        <p *ngIf="!isLoading" class="empfaenger-dialog-shell__embedded-hint">{{ footerHint }}</p>
    </div>
</div>
